export default __webpack_public_path__ + "static/media/step1-assessment-results.6077577c.gif";